/**
 * GDPR-compliant cookie consent banner for analytics tracking
 */

import { Box, Paper, Typography, Button, Stack, Link } from "@mui/material";

interface CookieConsentBannerProps {
  onAccept: () => void;
  onDecline: () => void;
  show: boolean;
}

export function CookieConsentBanner({
  onAccept,
  onDecline,
  show,
}: CookieConsentBannerProps) {
  if (!show) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        p: 2,
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 3,
          maxWidth: 600,
          mx: "auto",
          backgroundColor: "background.paper",
        }}
      >
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
          🍪 Cookie Consent
        </Typography>

        <Typography variant="body2" paragraph>
          We use cookies and analytics to improve your experience and understand
          how our service is used. Your privacy is important to us.
        </Typography>

        <Typography variant="caption" color="text.secondary" paragraph>
          By accepting, you agree to our use of analytics cookies.{" "}
          <Link
            href="/privacy"
            target="_blank"
            underline="hover"
            sx={{ fontWeight: 500 }}
          >
            Privacy Policy
          </Link>
        </Typography>

        <Stack direction="row" spacing={2}>
          <Button
            variant="contained"
            onClick={onAccept}
            fullWidth
            sx={{ fontWeight: 600 }}
          >
            Accept
          </Button>
          <Button
            variant="outlined"
            onClick={onDecline}
            fullWidth
            sx={{ fontWeight: 600 }}
          >
            Decline
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}
